import React from 'react';

const CharacterizationLegend = () => {
  const displayOrder = (
    <>
      <div className='report-table__legend-block'>
        <div className='report-table__legend-cell report-table__legend--not-available' />
        <span>
          Not
          <br />
          Measured
        </span>
      </div>
      <div className='report-table__legend-block'>
        <div className='report-table__legend-cell report-table__legend--green'>S</div>
        <span>Satisfied</span>
      </div>
      <div className='report-table__legend-block'>
        <div className='report-table__legend-cell report-table__legend--yellow'>P</div>
        <span>Partial</span>
      </div>
      <div className='report-table__legend-block'>
        <div className='report-table__legend-cell report-table__legend--red'>D</div>
        <span>Deficient</span>
      </div>
    </>
  );

  return (
    <div className='report-table__legend-section'>
      <div className='report-table__legend'>{displayOrder}</div>
    </div>
  );
};

export default CharacterizationLegend;
